import {
    GET_CHARGEBACK_STATUS_DEF,
    GET_CHARGEBACK_STATUS_DEF_SUCCESS,
    CHARGEBACK_STATUS_DEF_API_ERROR
  } from "./actionTypes"

  export const getChargebackStatusDefList = () => ({
    type: GET_CHARGEBACK_STATUS_DEF,
  })
  
  export const getChargebackStatusDefListSuccess = record => ({
    type: GET_CHARGEBACK_STATUS_DEF_SUCCESS,
    payload: record,
  })
  
  export const apiChargebackStatusDefApiError = error => {
    return {
      type: CHARGEBACK_STATUS_DEF_API_ERROR,
      payload: error,
    }
  }
  